import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import { Tooltip } from 'seagull';
const TooltipAnchor = /*#__PURE__*/ forwardRef(function TooltipAnchor(_0, _1) {
    let _ref = [
        _0,
        _1
    ], [_ref1, ..._rest] = _ref, { children } = _ref1, rest = _object_without_properties(_ref1, [
        "children"
    ]), [ref] = _rest;
    return(// eslint-disable-next-line r15/forbid-elements -- MUI Tooltip clones children to inject ref + mouse handlers; only a forwardRef'd DOM element makes the tooltip fire over disabled inputs.
    /*#__PURE__*/ _jsx("div", _object_spread_props(_object_spread({
        ref: ref
    }, rest), {
        children: children
    })));
});
export const DisabledCellTooltip = (param)=>{
    let { title, children } = param;
    if (!title) return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
    return /*#__PURE__*/ _jsx(Tooltip, {
        title: title,
        placement: "top",
        children: /*#__PURE__*/ _jsx(TooltipAnchor, {
            children: children
        })
    });
};
